import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { Solicitud } from '@interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { AgregarDocumentosExtraComponent } from '../../components/ofertas-laborales/pages/solicitud/agregar-documentos-extra/agregar-documentos-extra.component';
import { DocumentosEstadosSolicitar } from '../../interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { SolicitudesService } from '../ofertas-laborales/solicitudes.service';
import { MediaService } from 'src/app/services/shared/media.service';
import { CryptoService } from '@services/crypto-js/crypto.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {

  private documentosSolicitar = new Subject<any>(); 
  private documentosEnviadosView = new Subject<any>(); 
  private solicitud: Solicitud;

  constructor(
        public dialog: MatDialog,
        private solicitudesService: SolicitudesService,
        private mediaService: MediaService,
        private cryptoService: CryptoService
  ) { }

  getDocumentosSolicitar(): Observable<any>   {
    return this.documentosSolicitar.asObservable();
  }

  setDocumentosSolicitar(idAdjunto: string) {    
    this.documentosSolicitar.next({ idAdjunto: idAdjunto});
  }

  _getDocumentosEnviadosView(): Observable<any>   {
    return this.documentosEnviadosView.asObservable();
  }

  _setDocumentosEnviadosView$(flag: boolean) {    
    this.documentosEnviadosView.next({ flag: true});
  }

  openDialogDocUpload(solicitud: Solicitud, idAdjunto: string, label: string, index: string): void {

      const dialogRef = this.dialog.open(AgregarDocumentosExtraComponent, {
        width: '800px',
        height: '650px',
       disableClose: true,
       data: {
                solicitud: solicitud,
                adjunto: idAdjunto,
                label,
                 labelButton: 'ACEPTAR',
                 accept : 'application/pdf, image/jpeg, image/jpg, image/png, image/heic, image/heif'
              }
      });

      
    dialogRef.afterClosed().subscribe(result => {
      if (result) {// este resulta esta relacionado al flarCargaCorrecta
        this.setDocumentosSolicitar(idAdjunto); // comunico que se cargo el documento   
      } else  {
            return;
      }

    });
  }

  async uploadDocumentoAdjunto(selectedFile: any, solicitud: Solicitud, adjunto: string) {
    let idUsuario;
     
    // controlo si exite la propiedad, porque cuando el backend retorna un objeto no popula en ocaciones.
    if (solicitud.usuario.hasOwnProperty('_id')) {
     idUsuario = solicitud.usuario._id; 
    } 
     else { 
        idUsuario = solicitud.usuario
    }       
     await this.mediaService.uploadOneAttachJobOfferFromWeb(
            selectedFile, idUsuario, 
            adjunto, solicitud._id, false
        ).then( async resp => {       
        // if (resp['ok']) { // COMENTADO POR SI SE QUIERE USAR 
        //     if (this.value === 100) {
        //         this.solicitudesService.setSolicitudSeleccionada(resp['solicitud']);
        //         this.flagLoading = false;
        //         this.flarCargaCorrecta = true;
        //     }
        // } else {
        //     this.flarCargaCorrecta = false;
        //     this.guiMsjService.msjFormSubmit('uploadDocumentERROR');
        // }
    });
  }

  async uploadDocumentoAdjuntoEncrypted(selectedFile: any, solicitud: Solicitud, adjunto: string) {
    let idUsuario;
     
    // controlo si exite la propiedad, porque cuando el backend retorna un objeto no popula en ocaciones.
    if (solicitud.usuario.hasOwnProperty('_id')) {
        idUsuario = solicitud.usuario._id; 
    } else { 
        idUsuario = solicitud.usuario;
    }       

    await this.mediaService.uploadOneAttachJobOfferFromWebEncrypted(
        selectedFile, 
        idUsuario, 
        adjunto, 
        solicitud._id, 
        false
    ).then(resp => {       
        console.log('Documento subido exitosamente (encriptado)');
    }).catch(error => {
        console.error('Error al subir documento encriptado:', error);
        throw error;
    });
  }


}

